var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCadArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22653 0C1.45744 0 1.68471 0.0916414 1.8258 0.26218L5.87127 5.1553C6.04291 5.36255 6.04291 5.63718 5.87127 5.84443L1.8258 10.7375C1.5978 11.0137 1.14507 11.0829 0.814164 10.8926C0.483617 10.7023 0.400708 10.3243 0.628708 10.0484L4.38909 5.50002L0.628708 0.951616C0.400708 0.675781 0.483617 0.297684 0.814164 0.107421C0.940346 0.0348969 1.08398 0 1.22653 0Z",
    fill: "#D8D8D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCadArrow);
export default __webpack_public_path__ + "static/media/icon_cad_arrow.345fcc6b454c22c0592e919f398d5caf.svg";
export { ForwardRef as ReactComponent };